class SubmitError {}
export class SubmitResult {
  constructor(res) {
    let failed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    this.validationErrors = [];
    this.failed = failed;
    if (res && res.errors) {
      this.validationErrors = res.errors;
    }
  }
}